import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { SocketService, ImportProgressData } from '../../../core/services/socket.service';
import { Observable, Subscription } from 'rxjs';
import { TablerModule } from '../ui/icons/tabler/tabler.module';

@Component({
  selector: 'app-import-progress-toast',
  standalone: true,
  imports: [CommonModule, NgClass, TablerModule],
  templateUrl: './import-progress-toast.component.html',
  styleUrls: ['./import-progress-toast.component.scss']
})
export class ImportProgressToastComponent implements OnInit, OnDestroy {
  @Input() imports: Map<string, ImportProgressData> = new Map();
  
  private subscription: Subscription = new Subscription();

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    console.log('🎯 [Toast Component] ngOnInit called');
    // Subscribe to import progress updates
    this.subscription.add(
      this.socketService.getImportProgress().subscribe(imports => {
        console.log('🎯 [Toast Component] Received imports update:', imports);
        console.log('🎯 [Toast Component] Imports size:', imports.size);
        console.log('🎯 [Toast Component] Imports array:', Array.from(imports.values()));
        this.imports = imports;
        console.log('🎯 [Toast Component] Current imports count:', this.imports.size);
        console.log('🎯 [Toast Component] Has imports:', this.hasImports());
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getToastClasses(status: string): string {
    switch (status) {
      case 'completed':
        return 'success';
      case 'failed':
        return 'error';
      case 'in_progress':
        return 'in-progress';
      default:
        return 'default';
    }
  }

  getStatusIndicatorClass(status: string): string {
    switch (status) {
      case 'completed':
        return 'success';
      case 'failed':
        return 'error';
      case 'in_progress':
        return 'in-progress';
      default:
        return 'default';
    }
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'completed':
        return 'check-circle';
      case 'failed':
        return 'x-circle';
      case 'in_progress':
        return 'loader-2';
      default:
        return 'info-circle';
    }
  }

  getProgressFillClass(status: string): string {
    switch (status) {
      case 'completed':
        return 'success';
      case 'failed':
        return 'error';
      case 'in_progress':
        return 'in-progress';
      default:
        return 'default';
    }
  }

  getImportTypeDisplay(importType: string): string {
    switch (importType) {
      case 'LEAD':
        return 'Leads';
      case 'PERSON':
        return 'Contacts';
      case 'COMPANY':
        return 'Companies';
      default:
        return importType;
    }
  }

  closeImport(importId: string) {
    this.socketService.closeImport(importId);
  }

  getImportArray(): ImportProgressData[] {
    return Array.from(this.imports.values());
  }

  hasImports(): boolean {
    return this.imports.size > 0;
  }

  getProgressPercentage(importData: ImportProgressData): number {
    return importData.totalRecords > 0 
      ? Math.round((importData.importedRecords / importData.totalRecords) * 100)
      : 0;
  }

  getSkippedCount(importData: ImportProgressData): number {
    // Use skippedRecords from backend if available, otherwise calculate from difference
    if (importData.skippedRecords !== undefined && importData.skippedRecords !== null) {
      return importData.skippedRecords;
    }
    // Fallback: calculate skipped as totalRecords - importedRecords
    const skipped = importData.totalRecords - importData.importedRecords;
    return skipped > 0 ? skipped : 0;
  }

  trackByImportId(index: number, importData: ImportProgressData): string {
    return importData.importId;
  }
}
